import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {frontendRouting} from "./frontend.routing";
import {FrontendComponent} from './frontend.component';
import {RouterModule} from "@angular/router";
import {PagesComponent} from "./pages/pages.component";
import { WelcomeComponent } from './welcome/welcome.component';
import {StyleguideComponent} from './styleguide/styleguide.component';
import { SiteHeaderComponent } from './_blocks/site-header/site-header.component';
import { SiteFooterComponent } from './_blocks/site-footer/site-footer.component';
import {ApiService} from "../services/api.service";
import {PagesService} from "../services/pages.service";
import { BreadcrumbsComponent } from './_blocks/breadcrumbs/breadcrumbs.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import {DMenuService} from "../services/menu.service";
import {UserService} from "../services/user.service";
import {FormBuilder, FormsModule, ReactiveFormsModule} from "@angular/forms";
import { SearchFormComponent } from './_blocks/search-form/search-form.component';
import {SearchService} from "../services/search.service";
import { ScoreCircleComponent } from './_blocks/score-circle/score-circle.component';
import { SearchComponent } from './search/search.component';
import {IngredientService} from "../services/ingredient.service";
import { TooltipComponent } from './_blocks/tooltip/tooltip.component';
import { ProductComponent } from './product/product.component';
import {ProductService} from "../services/product.service";
import { IngredientListComponent } from './_blocks/ingredient-list/ingredient-list.component';
import { ProductSearchComponent } from './product/search.component';
import { IngredientSearchComponent } from './ingredient/search.component';
import { PagerComponent } from './_blocks/pager/pager.component';
import { FrontendGuard } from './frontend.guard';
import { AnalyseComponent } from './analyse/analyse.component';
import {QuestionService} from "../services/question.service";
import { AnalysePagerComponent } from './analyse/pager.component';
import { AnalyseResultComponent } from './analyse/result.component';
import { MetatagService } from '../services/metatag.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    frontendRouting
  ],
  declarations: [
      FrontendComponent,
      PagesComponent,
      WelcomeComponent,
      StyleguideComponent,
      SiteHeaderComponent,
      SiteFooterComponent,
      BreadcrumbsComponent,
      LoginComponent,
      SignupComponent,
      SearchFormComponent,
      ScoreCircleComponent,
      SearchComponent,
      TooltipComponent,
      ProductComponent,
      IngredientListComponent,
      ProductSearchComponent,
      IngredientSearchComponent,
      PagerComponent,
      AnalyseComponent,
      AnalysePagerComponent,
      AnalyseResultComponent
  ],
  providers: [
      FrontendGuard,
      ApiService,
      DMenuService,
      PagesService,
      UserService,
      SearchService,
      IngredientService,
      ProductService,
      QuestionService,
      FormBuilder,
      MetatagService
  ]
})
export class FrontendModule {}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/frontend.module.ts